<ion-content>
  <a [href]="urlSanitized" id="conectimedButton" #conectimedButton></a>
</ion-content>
